// Keeps a desk sheet current without « Actualiser » (§8.8k): the red ⚠ on a
// payment taken in the form clears once the feed has read it in Vega — a
// minute or two after the desk keys it — so the sheet re-reads every minute
// while it is on screen, and at once when it comes back on screen.

import { useEffect } from 'react';

/** How often a sheet re-reads itself while on screen. */
export const SHEET_REFRESH_MS = 60_000;

export function useAutoRefresh(refresh: () => void, everyMs: number): void {
  useEffect(() => {
    if (everyMs <= 0) return;
    const onScreen = () => document.visibilityState !== 'hidden';
    const timer = setInterval(() => {
      if (onScreen()) refresh();
    }, everyMs);
    const onVisibility = () => {
      if (onScreen()) refresh();
    };
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [refresh, everyMs]);
}
